import { FC, Fragment } from 'react';
import { buildRedirectParams } from '../utils/buildRedirectUrl';
import { redirectToIdSite } from '../utils/redirectToIdSite';

const EmailNotVerified: FC = () => {
  const { redirectUrl } = buildRedirectParams();

  // TODO with oidc we shouldn't redirect to id site
  redirectToIdSite(redirectUrl, 'ONBOARDING');
  return <Fragment />;
};

export default EmailNotVerified;
